import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Section } from '../cmsBlocks';
import { ProductListingRelated } from '../productListing';

type RelatedProductsProps = {
    accessories: any[];
};

export default function RelatedProducts(props: RelatedProductsProps) {
    const { accessories } = props;
    const [relatedIndex, setRelatedIndex] = useState(0);

    const { t } = useTranslation('templatePages');

    const section1 = {
        align: 'center',
        title: t('recommended-articles'),
    };
       
    return (
        <Section className='relatedProducts' section={section1}>
            
            <ProductListingRelated
                columns='3'
                products={accessories.slice(relatedIndex, relatedIndex + 3)}
                scroll={{
                    isScrollable: true,
                    relatedIndex,
                    setRelatedIndex,
                    length: accessories.length,
                    listingWidth: 3,
                }}
            />
            
        </Section>
    );
}
